import { s as EMPTY_RECORD } from "./helpers-bwfx1e-Y.js";
import { a as isHTMLElement, n as containsOrEqualsElement } from "./element-BYgCE_iK.js";
import { n as LayerProvider, t as useLayer } from "./useLayer-BAVfmbNN.js";
import { c } from "react/compiler-runtime";
import { useEffect, useImperativeHandle, useRef } from "react";
import { styled } from "styled-components";
import { jsx } from "react/jsx-runtime";
const StyledLayer = /* @__PURE__ */ styled.div.withConfig({
	displayName: "StyledLayer",
	componentId: "sc-rx4xl1-0"
})({ position: "relative" });
function LayerChildren(props) {
	let $ = c(23), children, forwardedRef, onActivate, onFocus, restProps, t0;
	$[0] === props ? (children = $[1], forwardedRef = $[2], onActivate = $[3], onFocus = $[4], restProps = $[5], t0 = $[6]) : ({children, onActivate, onFocus, ref: forwardedRef, style: t0, ...restProps} = props, $[0] = props, $[1] = children, $[2] = forwardedRef, $[3] = onActivate, $[4] = onFocus, $[5] = restProps, $[6] = t0);
	let style = t0 === void 0 ? EMPTY_RECORD : t0, { zIndex, isTopLayer } = useLayer(), lastFocusedRef = useRef(null), ref = useRef(null), isTopLayerRef = useRef(isTopLayer), t1;
	$[7] === Symbol.for("react.memo_cache_sentinel") ? (t1 = () => ref.current, $[7] = t1) : t1 = $[7], useImperativeHandle(forwardedRef, t1);
	let t2, t3;
	$[8] !== isTopLayer || $[9] !== onActivate ? (t2 = () => {
		isTopLayerRef.current !== isTopLayer && isTopLayer && onActivate?.({ activeElement: lastFocusedRef.current }), isTopLayerRef.current = isTopLayer;
	}, t3 = [isTopLayer, onActivate], $[8] = isTopLayer, $[9] = onActivate, $[10] = t2, $[11] = t3) : (t2 = $[10], t3 = $[11]), useEffect(t2, t3);
	let t4;
	$[12] !== isTopLayer || $[13] !== onFocus ? (t4 = (event) => {
		onFocus?.(event);
		let rootElement = ref.current, target = document.activeElement;
		!isTopLayer || !rootElement || !target || isHTMLElement(target) && containsOrEqualsElement(rootElement, target) && (lastFocusedRef.current = target);
	}, $[12] = isTopLayer, $[13] = onFocus, $[14] = t4) : t4 = $[14];
	let handleFocus = t4, t5;
	$[15] !== style || $[16] !== zIndex ? (t5 = {
		...style,
		zIndex
	}, $[15] = style, $[16] = zIndex, $[17] = t5) : t5 = $[17];
	let t6;
	return $[18] !== children || $[19] !== handleFocus || $[20] !== restProps || $[21] !== t5 ? (t6 = /* @__PURE__ */ jsx(StyledLayer, {
		...restProps,
		"data-ui": "Layer",
		onFocus: handleFocus,
		ref,
		style: t5,
		children
	}), $[18] = children, $[19] = handleFocus, $[20] = restProps, $[21] = t5, $[22] = t6) : t6 = $[22], t6;
}
/**
* @public
*/
function Layer(props) {
	let $ = c(10), children, restProps, t0;
	$[0] === props ? (children = $[1], restProps = $[2], t0 = $[3]) : ({children, zOffset: t0, ...restProps} = props, $[0] = props, $[1] = children, $[2] = restProps, $[3] = t0);
	let zOffset = t0 === void 0 ? 1 : t0, t1;
	$[4] !== children || $[5] !== restProps ? (t1 = /* @__PURE__ */ jsx(LayerChildren, {
		...restProps,
		children
	}), $[4] = children, $[5] = restProps, $[6] = t1) : t1 = $[6];
	let t2;
	return $[7] !== t1 || $[8] !== zOffset ? (t2 = /* @__PURE__ */ jsx(LayerProvider, {
		zOffset,
		children: t1
	}), $[7] = t1, $[8] = zOffset, $[9] = t2) : t2 = $[9], t2;
}
export { Layer as t };

//# sourceMappingURL=layer-B98ynOf2.js.map